import React from 'react';
import useLocalStorage from '../../hooks/use-local-storage';
import ChatAuthorEntry from './chat-author-entry';
import ChatInput from './chat-input';
import { ChatMessage } from './use-chat-database';
import { ga } from '../../ga';

export default function ChatEntry(props: {
  onLeaveChat: () => void;
  sendMessage: (msg: ChatMessage, authorName: string) => void;
  viewerID: string;
}) {
  // Local storage for persisting between refresh
  const [authorName, setAuthorName] = useLocalStorage<string>('bxc:chat:name', null);

  const onInput = ({ name, text }) => {
    if (!text) return;
    props.sendMessage(
      {
        text,
        vid: props.viewerID,
      },
      authorName
    );
  };
  const leaveChat = (): void => {
    setAuthorName('');
    props.onLeaveChat();
    ga('send', 'event', 'chat', 'author', 'leaveChat');
  };

  return (
    <div className="boxcast-chat--inputcontainer">
      {authorName ? (
        <ChatInput name={authorName} onInput={onInput} leaveChat={leaveChat} />
      ) : (
        <ChatAuthorEntry
          onSetAuthor={(author: string) => {
            setAuthorName(author);
            ga('send', 'event', 'chat', 'author', 'setName');
          }}
        />
      )}
    </div>
  );
}
